import React, { FC, useCallback } from "react";
import { Button } from "antd";
import { useUpdateUser } from "./hooks";
import { ImageUploadInput } from "../fileUploads/ImageUploadInput";
import { EditOutlined } from "@ant-design/icons";

export const EditUserAvatarButton: FC = () => {
  const updateUser = useUpdateUser();
  const handleSelectImage = useCallback(
    (imageUrl: string) => updateUser({ imageUrl }),
    [updateUser]
  );

  return (
    <ImageUploadInput
      style={{ position: "absolute", bottom: 0, right: 0 }}
      onChange={handleSelectImage}
    >
      <Button
        icon={<EditOutlined />}
        shape="circle"
        className="bg-body"
        type="primary"
      />
    </ImageUploadInput>
  );
};
